export const SOCIAL_LINKS = {
  linkedin: 'https://www.linkedin.com/in/rokas-sileikis/',
  github: 'https://github.com/rokas-th',
  email: 'hello@rokas.org',
} as const;

export const SKILLS = {
  backend: ['Laravel', 'PHP', 'Rust', 'PostgreSQL', 'MySQL', 'REST APIs'],
  frontend: ['React', 'TypeScript', 'Tailwind CSS', 'WebAssembly', 'Vite'],
  devops: ['Docker', 'Fly.io', 'Cloudflare', 'GitHub Actions'],
} as const;

export interface Project {
  id: string;
  slug: string;
  tags: string[];
  url?: string;
  demo?: boolean;
  outcome?: boolean;
  featured: boolean;
  status: 'live' | 'concept' | 'development' | 'coming-soon';
}

export const PROJECTS: Project[] = [
  {
    id: '1',
    slug: 'tipsytruck',
    tags: ['React', 'Tailwind', 'WebGL'],
    url: 'https://tipsytruck.com',
    outcome: true,
    featured: true,
    status: 'live',
  },
  {
    id: '2',
    slug: 'memory-globe',
    tags: ['Three.js', 'R3F', 'WebGL'],
    url: 'https://memory-globe.rokass.org',
    featured: true,
    status: 'live',
  },
  {
    id: '3',
    slug: 'ai-ui-generator',
    tags: ['Claude API', 'Cloudflare', 'Sandpack'],
    url: 'https://ai-ui-generator.rokass.org',
    featured: true,
    status: 'live',
  },
  {
    id: '4',
    slug: 'collab-canvas',
    tags: ['Yjs', 'PartyKit', 'Realtime'],
    url: 'https://collab-canvas.rokass.org',
    featured: true,
    status: 'development',
  },
  {
    id: '5',
    slug: 'tipsy-configurator',
    tags: ['R3F', 'Manifold', 'STL'],
    url: 'https://tipsy-configurator.rokass.org',
    featured: true,
    status: 'live',
  },
  {
    id: '6',
    slug: 'white-elephant',
    tags: ['React', 'Tailwind', 'i18n'],
    url: 'https://restaurant.rokass.org',
    outcome: true,
    featured: true,
    status: 'concept',
  },
  {
    id: '8',
    slug: 'rust-fractal',
    tags: ['Rust', 'WebAssembly', 'Canvas'],
    demo: true,
    featured: true,
    status: 'live',
  },
  {
    id: '7',
    slug: 'portfolio',
    tags: ['React', 'TypeScript', 'Tailwind'],
    featured: true,
    status: 'live',
  },
];

export const NAV_ITEMS = [
  { labelKey: 'common.services', hash: 'services' },
  { labelKey: 'common.projects', hash: 'projects' },
  { labelKey: 'common.about', hash: 'about' },
  { labelKey: 'common.contact', hash: 'contact' },
] as const;
